import { FC, useMemo } from 'react';
import { ColumnFilterElementTemplateOptions } from 'primereact/column';

import DropdownField from '../DropdownField/DropdownField';
import { TableData } from '../Table/types';

type TableDropdownFilterProps = {
  data: TableData;
  fieldName: string;
  options: ColumnFilterElementTemplateOptions;
};

const TableDropdownFilter: FC<TableDropdownFilterProps> = ({
  data,
  fieldName,
  options,
}) => {
  const getOptionsByField = useMemo(() => {
    const filteredData = data?.filter(
      (item) => item[fieldName] !== null && item[fieldName] !== undefined
    );

    const uniqueValues = Array.from(
      new Set(
        filteredData?.map((item) => {
          const value = item[fieldName];
          if (value === undefined || value === null) {
            return value;
          }
          const stringValue = value.toString().toLowerCase();
          if (stringValue === 'true') {
            return 'true';
          }
          if (stringValue === 'false') {
            return 'false';
          }
          return value;
        })
      )
    );

    return uniqueValues.map((value) => {
      if (value === 'true') {
        return {
          name: 'Sí',
          value: 'true',
        };
      }
      if (value === 'false') {
        return {
          name: 'No',
          value: 'false',
        };
      }
      return {
        name: String(value),
        value: String(value),
      };
    });
  }, [data, fieldName]);

  return (
    <DropdownField
      options={getOptionsByField}
      value={options?.value}
      onChange={(e) => {
        if (options?.filterApplyCallback) {
          options.filterApplyCallback(e.value, options.index);
        }
      }}
      showClear
    />
  );
};

export default TableDropdownFilter;
